import {ID, Response} from '../../../../../_metronic/helpers'
import {Paging} from '../../../../models/Response'
import {CriminalOffence} from '../../../criminalOffences/core/_model'
import {IBaseReport} from '../../../../models/IBaseReport'
import {IButtonPermission} from '../../../../models/IButtonPermission'

export type Judol = {
  attentionLevel?: number
  id?: ID
  reportId?: number
  policeReportNo?: string
  policeReportDate?: string
  reportDate?: string
  caseStatusId?: number
  crimeScene?: string
  crimeTime?: string
  chronology?: string
  caseStatusName?: string
  evidences: ReportEvidence[]
  urls: ReportJudolUrl[]
  criminalOffences: CriminalOffence[]
  modusOperandi: any[]
  reporteds: Reported[]
  reporters: Reporter[]
  suspects: Suspect[]
  amplifications?: any
  isSubmit?: boolean
  attentionDesc?: string
  statusName?: string
  satwilId?: number
  satwilName?: string
  createdAt?: string
  statusId?: number
  report?: IBaseReport
  button?: IButtonPermission
  suspectRequired?: boolean
}

export type JudolQueryResponse = Response<Paging<Judol>>

export const initialJudol: Judol = {
  id: undefined,
  policeReportNo: '',
  policeReportDate: '',
  caseStatusId: 0,
  crimeScene: '',
  crimeTime: '',
  chronology: '',
  caseStatusName: '',
  evidences: [],
  urls: [],
  criminalOffences: [],
  modusOperandi: [],
  reporteds: [],
  reporters: [],
  suspects: [],
  attentionDesc: '',
}

export interface Reported {
  id?: ID
  key?: string
  name?: string
  gender?: number
  nik?: string
  address?: string
  pob?: string
  dob?: string
  jobId?: string
  age?: number
  statusId?: number
}

export interface Reporter extends Reported {}

export const initialReporter: Reporter = {
  address: '',
  age: 0,
  dob: '',
  gender: 0,
  id: undefined,
  jobId: '',
  key: '',
  name: '',
  nik: '',
  pob: '',
  statusId: 0,
}

export interface Suspect extends Reported {
  jobName?: string
  roleId?: number
}

export interface ReportEvidence {
  key?: string
  id?: number
  evidenceId?: number
  evidenceName?: string
  description?: string
  qty?: number
  itemUnitId?: number
  name?: string
  itemUnitName?: string
  gender?: number
  valueAmt?: number
  index?: number
}

export interface ReportJudolUrl {
  key?: string
  id?: number
  judolId?: ID
  title?: string
  description?: string
  url?: string
}
